module.exports = __webpack_public_path__ + "img/wcfa-face-bg.e2530485.png";